
import { Route, Switch, RouteComponentProps } from 'react-router-dom'
import { withProps } from 'src/utils/withProps';
import {Android} from './Android'
import {Ios} from './Ios'

type TParams = { id: string };

export function Network(props: RouteComponentProps<TParams>) {
    return (
        <div>
            <Switch>
                <Route path={[
                    '/network/android/:sdk_version',
                    '/network/android'
                ]} component={withProps(Android, props)}  />
                <Route path={'/network/ios'} component={withProps(Ios, props)}  />
            </Switch>
        </div>
    );
}       